import { render } from "./DarkModeToggle.vue?vue&type=template&id=6ddc095c"
import script from "./DarkModeToggle.vue?vue&type=script&lang=js"
export * from "./DarkModeToggle.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__